const EMPLOYEE_TYPES = new Set(["mitarbeiter", "kanzlei_mitarbeiter"]);

/**
 * Einheitliche Konto-Beschriftung für Listen (Admin, Organisation/Team, Konten):
 * - Mitarbeiter / Kanzlei-Mitarbeiter -> nur "Name" (Fallback E-Mail)
 * - Firmen (Unternehmer, Steuerberater) sowie Einzelnutzer MIT hinterlegter Firma
 *   -> "Firma | Eigentümer" (Eigentümer = hinterlegter Name/Ansprechpartner)
 * - sonst (keine Firma) -> "Name" (Fallback E-Mail)
 */
export function accountLabel(acct) {
  if (!acct) return "";
  const name = (acct.name || "").trim();
  const company = (acct.company || "").trim();
  const email = (acct.email || "").trim();
  const type = acct.account_type || "";
  if (EMPLOYEE_TYPES.has(type)) {
    return name || email;
  }
  if (company) {
    return [company, name].filter(Boolean).join(" | ") || email;
  }
  return name || email;
}
